const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const TempCanvas = require("../util/TempCanvas");
const CanvasView = require("./Canvas");
const MeasuredEl = require("./MeasuredEl");
const colors = require("../util/ColorUtil").getCurrentScheme();

module.exports = createReactClass({
	displayName: "PartialProgressBar",

	propTypes: {
		//The size in pixels specifying the width/height that this progress icon should be.
		//If not specified, the progress icon will size itself using a MeasuredEl.
		size: PT.number,
		className: PT.string,
		percentComplete: PT.number.isRequired,
	},

	getInitialState: function() {
		return {
			canvas: TempCanvas.requestCanvas(),
		};
	},

	componentWillUnmount: function() {
		TempCanvas.releaseCanvas(this.state.canvas);
	},

	drawProgressBar: function(context) {
		const cWidth = context.getWidth();
		const cHeight = context.getHeight();

		context.save();
		const startX = 0;
		const startY = 0;
		context.clearRect(startX, startY, cWidth, cHeight);

		const shadowOffset = 1;

		// Draw the shadow first
		context
			.bp()
			.rect(
				startX + shadowOffset,
				startY + shadowOffset,
				cWidth - shadowOffset,
				cHeight - shadowOffset
			)
			.fill(colors.defaultDarkShadow);

		// Fill in the gray background first
		context
			.bp()
			.rect(startX, startY, cWidth - shadowOffset, cHeight - shadowOffset)
			.fill(colors.grayProgressBackground);

		// Fill in the yellow progress
		context.beginPath();
		// Always show at least a sliver of progress.
		const percentComplete = Math.max(this.props.percentComplete, 0.05);
		const offset = 0.01;
		const endX1 = Math.min(
			startX + cWidth - shadowOffset,
			startX + cWidth * (percentComplete + offset)
		);
		let endX2 = startX + cWidth * (percentComplete - offset);
		if (percentComplete === 1) {
			endX2 = endX1;
		}
		context.moveTo(startX, startY);
		context.lineTo(endX1, startY);
		context.lineTo(endX2, cHeight - shadowOffset);
		context.lineTo(startX, cHeight - shadowOffset);

		context.closePath();
		context.fill(colors.partialProgressFill);
		context.restore();
	},

	render: function() {
		const className = this.props.className;

		if (this.props.size) {
			return (
				<CanvasView
					className={className}
					draw={this.drawProgressBar}
					width={this.props.size}
					height={this.props.size}
				/>
			);
		}
		return (
			<MeasuredEl className={className}>
				<CanvasView
					draw={this.drawProgressBar}
					width={this.props.size}
					height={this.props.size}
				/>
			</MeasuredEl>
		);
	},
});
